enum ErrorCodes {
	//In future: Merge with ErrorCodes from front-display and add to the lib
	UNEXPECTED_EXCEPTION = 'UNEXPECTED_EXCEPTION',
	FILE_IS_NOT_JS_OBJECT = '40101',
	FILE_DOES_NOT_HAVE_UID = '40102',
	FILE_FLAGS_ARE_NOT_IN_ARRAY = '40103',
	FILE_FLAG_IS_NOT_OBJECT = '40104',
	COMMAND_TYPE_NOT_VALID = '40401',
	COMMAND_TYPE_IS_TOO_LONG = '40402',
	HARDWARE_LED_COLOR_IS_NOT_STRING = '40601',
	HARDWARE_LED_COLOR_IS_NOT_VALID = '40602',
	FILE_NOT_FOUND_IN_CACHE = '49902',
	OFFLINE_CACHE_UID_NOT_VALID = '40901',
	OFFLINE_CACHE_HEADERS_NOT_VALID = '40902',
	STREAM_INVALID_PROTOCOL_TYPE = '41401',
	VIDEO_WAS_NOT_PLAYED_YET = '41501',
	VIDEO_WAS_STOPPED_ALREADY = '41502',
	SECURITY_PIN_CODE_INVALID = '41701',
}

export default ErrorCodes;
